/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated with ApiClientGenerator, using the NSwag toolchain
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosRequestConfig, AxiosPromise, AxiosInstance, CancelToken } from 'axios';
import { injectable, inject, optional, symbolToken } from '@servicetitan/react-ioc';
// @ts-ignore: needed for Date serialization if a DateTime parameter has an Unspecified attribute on it
import moment from 'moment';

export interface IOptInApi {
    optIn(request: OptInRequest, cancelToken?: CancelToken): AxiosPromise<FileResponse>;
}

interface ClientApiConfig {
    baseUrl: string;
    axios: AxiosInstance;
}

export const BASE_URL_TOKEN_OptInApi = symbolToken<string>('BASE_URL_TOKEN', false);
export const AXIOS_TOKEN_OptInApi = symbolToken<string>('AXIOS_TOKEN', false);

@injectable()
export class OptInApi implements IOptInApi {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;
    protected readonly opts: ClientApiConfig;

    constructor(
        @inject(BASE_URL_TOKEN_OptInApi) @optional() baseUrl = '',
        @inject(AXIOS_TOKEN_OptInApi) @optional() axiosInstance = axios,
    ) {

        this.opts = {
            baseUrl,
            axios: axiosInstance,
        };
    }

    optIn(request: OptInRequest, cancelToken?: CancelToken): AxiosPromise<FileResponse> {
        let url_ = "/api/OptIn";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = request;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            cancelToken,
            data: content_,
            responseType: 'blob',
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.opts.axios.request<FileResponse>(options_);
    }
}

export interface OptInRequest {
    email: string;
    tenantId: string;
    currentPartitionId: string;
    messageData?: string | undefined;
    signature?: string | undefined;
}

export type FileResponse = Blob;
